/*
 * Velour — ürün kartı AJAX sepete ekle.
 * Dawn'ın cart-notification / cart-drawer mekanizmasına bağlanır:
 *   - cart elementi varsa getSectionsToRender() ile "sections" gönderir,
 *     başarıda renderContents(response) çağırır (notification/drawer açılır).
 *   - cart elementi yoksa (örn. cart page) /cart sayfasına yönlendirir.
 *   - PUB_SUB_EVENTS.cartUpdate publish eder (header sayacı vb. güncellensin).
 * Variant'lı (default olmayan) ürünlerde sepete eklemez, PDP'ye yönlendirir.
 * Global scope kirletmez; tek delegated submit listener.
 */
(function () {
  'use strict';

  // Aynı sayfada birden çok section bu script'i yükleyebilir (vl-featured,
  // collection grid). Tek submit listener bağlansın diye idempotent guard —
  // yoksa çift bağlanır ve tek tıkta 2 ürün eklenir.
  if (window.__vlCardInit) return;
  window.__vlCardInit = true;

  function getCartElement() {
    return document.querySelector('cart-notification') || document.querySelector('cart-drawer');
  }

  function setButtonState(button, state) {
    button.classList.remove('is-loading', 'is-added');
    if (state === 'loading') {
      button.classList.add('is-loading');
      button.setAttribute('aria-disabled', 'true');
    } else if (state === 'added') {
      button.classList.add('is-added');
      button.removeAttribute('aria-disabled');
    } else {
      button.removeAttribute('aria-disabled');
    }
  }

  function publishCartUpdate(response) {
    if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      publish(PUB_SUB_EVENTS.cartUpdate, {
        source: 'vl-product-card',
        productVariantId: response && response.variant_id,
        cartData: response,
      });
    }
  }

  function onSubmit(event) {
    const form = event.target.closest('[data-vl-add-form]');
    if (!form) return;

    event.preventDefault();

    const button = form.querySelector('.vl-card__add-btn');
    if (!button || button.getAttribute('aria-disabled') === 'true') return;

    // Birden çok varyant varsa: doğru kombinasyon PDP'de seçilmeli.
    const needsOptions = button.getAttribute('data-vl-needs-options');
    if (needsOptions) {
      window.location.href = needsOptions;
      return;
    }

    const cart = getCartElement();
    const config =
      typeof fetchConfig === 'function'
        ? fetchConfig('javascript')
        : { method: 'POST', headers: { Accept: 'application/javascript' } };
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];

    const formData = new FormData(form);
    if (cart && typeof cart.getSectionsToRender === 'function') {
      formData.append('sections', cart.getSectionsToRender().map((section) => section.id));
      formData.append('sections_url', window.location.pathname);
      if (typeof cart.setActiveElement === 'function') {
        cart.setActiveElement(document.activeElement);
      }
    }
    config.body = formData;

    setButtonState(button, 'loading');

    const cartAddUrl = (window.routes && window.routes.cart_add_url) || '/cart/add';

    fetch(cartAddUrl, config)
      .then((response) => response.json())
      .then((response) => {
        if (response.status) {
          // Hata (örn. stokta yok): kullanıcıyı PDP'ye yönlendir.
          setButtonState(button, 'idle');
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartError, {
              source: 'vl-product-card',
              errors: response.errors || response.description,
              message: response.message,
            });
          }
          return;
        }

        publishCartUpdate(response);

        if (cart && typeof cart.renderContents === 'function') {
          if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
          cart.renderContents(response);
        } else if (window.routes && window.routes.cart_url) {
          window.location = window.routes.cart_url;
        }

        setButtonState(button, 'added');
        setTimeout(() => setButtonState(button, 'idle'), 1600);
      })
      .catch((error) => {
        console.error(error);
        setButtonState(button, 'idle');
      });
  }

  document.addEventListener('submit', onSubmit);
})();
